module.exports = __webpack_public_path__ + "img/activity.57509d12.png";